<template>
  <div class="echart" ref="echart" :style="echartStyle"></div>
</template>

<script>
import echart from "@/utils/echart";
export default {
  props: {
    echartStyle: {
      type: Object,
      default() {
        return { 
          width: '100%',
          height: '30px;'
         };
      },
    },
    datax: {
      type: Array,
      default() {
        return [];
      },
    },
    datay: {
      type: Array,
      default() {
        return [];
      },
    },
    isScale: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    options() {
      return {
        xAxis: {
          type: 'category',
          boundaryGap: false,
          show: false
        },
        yAxis: {
          type: 'value',
          show: false,
        },
        grid: {
          show: false,
          top: "0%",
          left: '2%',
          right: "2%",
          bottom: "0%",
        },
        series: [
          {
            data: [100, 120, 100, 90, 30,100, 120, 100, 90, 30],
            type: 'bar',
            areaStyle: {},
            barWidth: 16,
            // barGap: 0,
            itemStyle:{
              color: "#24c69a",
              borderColor:'#ccc',
              borderWidth: 0,
            }
          }
        ]
      }
    },
  },
  watch: {
    options: {
      handler() {
        this.init()
      },
      deep: true
    }
    
  },
  data() {
    return {};
  },
  methods: {
    init() {
      const divFef = this.$refs.echart;
      const { setData } = echart(divFef);
      setData(this.options);
    },
  },
  mounted() {
   this.init()
  },
};
</script>

<style lang="stylus" scoped></style>
